// jQuery
window.jQuery = window.$ = require('jquery');
// Bootstrap Custom Files
const bsCustomFileInput = require('bs-custom-file-input');
$(function () {
    bsCustomFileInput.init();
});
// Popper JS
require('popper.js');
